// extracted by mini-css-extract-plugin
export default {"empty_text":"Empty_empty_text__+in4g","empty_tips":"Empty_empty_tips__9ShmN","empty_img":"Empty_empty_img__RR0OJ"};